import { CompensationType } from '@libs/types';

function camelToHuman(camelCaseString: string, capitalize = false): string {
  if (!camelCaseString) {
    return '';
  }

  let s1: string = camelCaseString.replace(/([A-Z])/g, ' $1').trim();
  s1 = s1.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return capitalize ? s1.charAt(0).toUpperCase() + s1.slice(1) : s1;
}

export const camelToSnake = (str: string) => {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
};

export const camelToKebab = (str: string) => {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase();
};

type HumanizeType = 'camel' | 'snake' | 'kebab';

export const toHuman = (type: HumanizeType, str: string, capitalize = false) => {
  if (type === 'camel') {
    return camelToHuman(str, capitalize);
  }

  if (type === 'snake') {
    return capitalize ? str.replace(/([A-Z])/g, '_$1').toUpperCase() : str.replace(/([A-Z])/g, '_$1').toLowerCase();
  }

  if (type === 'kebab') {
    return capitalize ? str.replace(/([A-Z])/g, '-$1').toUpperCase() : str.replace(/([A-Z])/g, '-$1').toLowerCase();
  }

  return str;
};

export const toHumanArray = (type: HumanizeType, arr: string[], capitalize = false) => {
  return arr.map((item) => toHuman(type, item, capitalize));
};

export const toHumanSalary = (
  compensationMin?: number,
  compensationMax?: number,
  compensationType?: CompensationType,
) => {
  if (!compensationMin && !compensationMax && !compensationType) {
    return 'Undisclosed';
  }

  const config = { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 } as const;

  const min = Intl.NumberFormat('en-US', config).format(compensationMin || 0);
  const max = Intl.NumberFormat('en-US', config).format(compensationMax || 0);

  const type =
    compensationType === 'yearly'
      ? 'yr'
      : compensationType === 'monthly'
      ? 'mo'
      : compensationType === 'weekly'
      ? 'wk'
      : 'hr';

  return `${min} - ${max} / ${type}`;
};
